import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/scoreboard_assists', {
        template: require('./scoreboard_assists.html'),
        controller: 'ScoreboardAssistsController'
    });
})
.controller('ScoreboardAssistsController', function($scope, $location, $modal, Account, ScoreboardAssist, Config) {
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.s || ($scope.s = 'id');
    $scope.config = Config;
    $scope.loading = true;

    const params = _.pick($scope, 'q', 's', 'p');

    if (params.q && params.q.match(/^[a-zA-Z0-9]+$/)) {
        // NOTE: the `id` is just the MAC address with an "s" prefix
        if (params.q.startsWith('s')) {
          params.q = params.q.substring(1);
        }
        params.q = `mac_address:*${params.q}*`;
    }

    if ($scope.f.account && $scope.f.account.active) {
        params['filter.account_id'] = $scope.f.account.id;
    }

    $scope.scoreboardAssists = ScoreboardAssist.query(params, function(data, getResponseHeader) {
        $scope.loading = false;
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });

    $scope.createManufacturingScoreboardAssists = () => {
        $modal.open({ template: require('./scoreboard_assists_new_mfg_form.html'), controller: 'ScoreboardAssistsNewMfgController', size: 'lg', backdrop: 'static' }).result.then(mfgAccountId => {
            Account.get({id: mfgAccountId}, a => {
                const filter = "account:" + encodeURIComponent(JSON.stringify(_.extend({active: true}, _.pick(a, 'id', 'name'))));
                $location.url(`/scoreboard_assists?f=${encodeURIComponent(filter)}`);
            }, err => {
                console.error(err);
                toaster.pop({
                    type: 'error',
                    body: `Error loading manufacturing account. Please try again.`,
                    timeout: 2000
                });
            });
        });
    };
});


// WEBPACK FOOTER //
// ./views/scoreboard_assists/scoreboard_assists_controller.js